/* GALERÍA VIVA — el director de escena de la portada. Cuadros Splash.

   Solo se carga en la portada. Decide si se anima (movimiento permitido,
   observador disponible) y entonces — y solo entonces — marca piezas con
   [data-vivo] y pone `cs-vivo-anima` en <html>. Sin esa clase, el CSS de
   cs-vivo.css no oculta absolutamente nada: la regla de oro de reveal.js,
   un cuadro NUNCA puede quedarse invisible, sigue mandando aquí.

   Truco para verlo con "reducir movimiento" activado (el Windows de
   Gabriel, ver su ficha): añadir ?vivo=si a la URL fuerza la función una
   vez, y ?vivo=no la apaga. No toca nada del sistema: es solo para poder
   enseñar las animaciones a quien las tiene desactivadas.

   Piezas:
     1. Titular del hero palabra a palabra + resto del panel por orden.
     2. Entrada escalonada de las piezas de cada sección (con las tres
        redes de seguridad de siempre: ya-visible, observador y rescate).
     3. Mosaico: la ficha se inclina siguiendo el ratón (2 grados, lenta).
     4. Contadores de obras que cuentan hasta su cifra al entrar.
     5. El medidor del sofá: a TU medida, con la banda del tamaño ideal.
        (El medidor funciona SIEMPRE, también sin animaciones: es un
        control útil, no un adorno.)
*/

(function () {
  var RESCATE = 6000; /* a los 6 s todo visible, dispare lo que dispare */

  /* Caja negra para depurar coreografías sin adivinar: cada hito apunta
     qué pasó y cuándo. Se consulta con window.csVivo en la consola. */
  var caja = { eventos: [] };
  window.csVivo = caja;
  function apunte(que, dato) {
    caja.eventos.push({ t: Math.round(performance.now()), que: que, dato: dato });
  }

  var parametro = null;
  try {
    parametro = new URLSearchParams(window.location.search).get('vivo');
  } catch (e) {
    /* URLSearchParams falta en navegadores muy viejos: sin forzado */
  }

  var reducido =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* EL INTERRUPTOR SE RECUERDA DURANTE LA VISITA (15 sep 2026).
     Gabriel tiene «reducir movimiento» puesto en su Windows, asi que sin
     ?vivo=si no ve ni una de las animaciones que encarga. Y el parametro se
     perdia en cuanto pinchaba un enlace — justo lo que se hace al revisar la
     tienda: portada, coleccion, ficha. Ahora la eleccion dura lo que dure la
     pestana, y basta con ponerlo una vez.

     sessionStorage y no localStorage a proposito: esto es una herramienta
     para revisar, no un ajuste del visitante. Al cerrar la pestana vuelve a
     mandar lo que diga el sistema, que es lo correcto. */
  try {
    if (parametro === 'si' || parametro === 'no') {
      sessionStorage.setItem('cs-vivo', parametro);
    } else if (!parametro) {
      parametro = sessionStorage.getItem('cs-vivo');
    }
  } catch (e) {
    /* modo privado o almacenamiento bloqueado: manda la URL y ya esta */
  }

  var forzado = parametro === 'si';
  var apagado = parametro === 'no';
  var anima = !apagado && (!reducido || forzado) && 'IntersectionObserver' in window;

  /* ---------- 5. El medidor del sofá (funciona siempre) ---------- */

  function arrancarMedidor() {
    var medidor = document.querySelector('[data-cs-medidor]');
    if (!medidor) return;

    var escena = medidor.closest('.cs-talla');
    var rango = medidor.querySelector('[data-cs-medidor-rango]');
    var salida = medidor.querySelector('[data-cs-medidor-cm]');
    var consejo = medidor.querySelector('[data-cs-medidor-consejo]');
    var banda = escena && escena.querySelector('[data-cs-banda]');
    var bandaRotulo = escena && escena.querySelector('[data-cs-banda-rotulo]');
    var pie = escena && escena.querySelector('.cs-talla__pie');
    if (!escena || !rango) return;

    medidor.hidden = false;
    if (banda) banda.hidden = false;
    if (bandaRotulo) bandaRotulo.hidden = false;

    var tallas = Array.prototype.map.call(
      escena.querySelectorAll('.cs-talla__una'),
      function (el) {
        var caja = el.querySelector('.cs-talla__caja');
        return {
          el: el,
          ancho: caja ? parseInt(caja.style.getPropertyValue('--w'), 10) || 0 : 0,
          alto: caja ? parseInt(caja.style.getPropertyValue('--h'), 10) || 0 : 0,
        };
      }
    );

    function aplicar() {
      var cm = parseInt(rango.value, 10) || 200;
      var desde = Math.round((cm * 0.5) / 5) * 5;
      var hasta = Math.round((cm * 0.75) / 5) * 5;

      escena.style.setProperty('--sofa-cm', cm);
      if (salida) salida.textContent = cm + ' cm';
      if (pie) pie.textContent = 'Tu mueble: ' + cm + ' cm, a la misma escala';
      if (bandaRotulo) bandaRotulo.textContent = 'tu cuadro ideal: ' + desde + '–' + hasta + ' cm de ancho';

      var clava = null;
      tallas.forEach(function (t) {
        var dentro = t.ancho >= desde && t.ancho <= hasta;
        t.el.classList.toggle('es-fuera', !dentro);
        t.el.classList.remove('es-clava');
        if (dentro && (!clava || t.ancho > clava.ancho)) clava = t;
      });
      if (clava) clava.el.classList.add('es-clava');

      if (consejo) {
        if (clava) {
          consejo.innerHTML =
            'Para ' + cm + ' cm, busca obras de <b>' + desde + ' a ' + hasta +
            ' cm de ancho</b> — la de <b>' + clava.ancho + ' × ' + clava.alto +
            '</b> te encaja de lleno.';
        } else {
          consejo.innerHTML =
            'Para ' + cm + ' cm, busca obras de <b>' + desde + ' a ' + hasta +
            ' cm de ancho</b>. En cada ficha tienes la guía con todas las tallas.';
        }
      }
    }

    rango.addEventListener('input', aplicar);
    aplicar();
  }

  /* ---------- 1. El hero, por orden de lectura ---------- */

  function coreografiarHero() {
    var titulo = document.querySelector('.custom-hero__heading');
    if (!titulo || titulo.dataset.vivoHecho) return;
    titulo.dataset.vivoHecho = '1';

    /* Partir el titular en palabras, cada una dentro de su renglón. Se
       reconstruye con textContent: si el título trajera algún marcado,
       se pierde el marcado pero jamás el texto. */
    var palabras = (titulo.textContent || '').trim().split(/\s+/);
    if (!palabras.length) return;

    titulo.textContent = '';
    palabras.forEach(function (palabra, i) {
      var caja = document.createElement('span');
      caja.className = 'custom-hero__palabra';
      var alma = document.createElement('span');
      alma.textContent = palabra;
      alma.style.setProperty('--vivo-espera', 250 + i * 120 + 'ms');
      caja.appendChild(alma);
      titulo.appendChild(caja);
      if (i < palabras.length - 1) titulo.appendChild(document.createTextNode(' '));
    });
  }

  /* ---------- 2. Las piezas entran al pasear ---------- */

  function coreografiarEntradas() {
    var piezas = [];

    /* Cabeceras de sección y bloques grandes: de uno en uno. */
    document
      .querySelectorAll('.cs-head, .cs-cat__buscador, .cs-mosaico-caja, .cs-talla__escena, .cs-talla__medidor')
      .forEach(function (el) {
        piezas.push({ el: el, espera: 0 });
      });

    /* Las obras, escalonadas dentro de su fila. */
    document.querySelectorAll('.cs-obras').forEach(function (grupo) {
      Array.prototype.forEach.call(grupo.querySelectorAll('.cs-obra'), function (obra, i) {
        piezas.push({ el: obra, espera: (i % 5) * 140 });
      });
    });

    if (!piezas.length) return;

    piezas.forEach(function (p) {
      /* No re-ocultar lo que ya está a la vista al cargar: eso entra ya,
         con su animación, sin parpadeo previo. */
      p.el.setAttribute('data-vivo', '');
      p.el.style.setProperty('--vivo-espera', p.espera + 'ms');
    });

    var destapar = function () {
      apunte('rescate', document.querySelectorAll('[data-vivo]:not(.is-vivo)').length);
      piezas.forEach(function (p) {
        p.el.classList.add('is-vivo');
      });
    };

    /* Red 2: el rescate. */
    setTimeout(destapar, RESCATE);

    /* Red 1: lo visible al cargar, ya. */
    var alto = window.innerHeight || document.documentElement.clientHeight;
    var red1 = 0;
    piezas.forEach(function (p) {
      var r = p.el.getBoundingClientRect();
      if (r.top < alto && r.bottom > 0) {
        p.el.classList.add('is-vivo');
        red1++;
      }
    });
    apunte('red1', { visibles: red1, ventana: alto, alturaPagina: document.documentElement.scrollHeight });

    var io = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(e.target);
          e.target.classList.add('is-vivo');
          apunte('io', (e.target.className || '').toString().slice(0, 30));
        });
      },
      { threshold: 0.08 }
    );

    var observadas = 0;
    piezas.forEach(function (p) {
      if (!p.el.classList.contains('is-vivo')) {
        io.observe(p.el);
        observadas++;
      }
    });
    apunte('observando', observadas);
  }

  /* ---------- 3. El mosaico sigue a la mano ---------- */

  function coreografiarMosaico() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    var MAX = 2.2; /* grados: una insinuación, no una atracción de feria */

    document.querySelectorAll('.cs-tema').forEach(function (ficha) {
      ficha.addEventListener('mousemove', function (e) {
        var r = ficha.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        ficha.style.setProperty('--vivo-ry', (x * MAX).toFixed(2) + 'deg');
        ficha.style.setProperty('--vivo-rx', (-y * MAX).toFixed(2) + 'deg');
      });
      ficha.addEventListener('mouseleave', function () {
        ficha.style.setProperty('--vivo-ry', '0deg');
        ficha.style.setProperty('--vivo-rx', '0deg');
      });
    });
  }

  /* ---------- 4. Los números cuentan ---------- */

  function coreografiarContadores() {
    var contadores = document.querySelectorAll('.cs-tema__c');
    if (!contadores.length) return;

    var io = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(e.target);
          contar(e.target);
        });
      },
      { threshold: 0.4 }
    );

    contadores.forEach(function (n) {
      var texto = (n.textContent || '').trim();
      var cifra = parseInt(texto.replace(/[^\d]/g, ''), 10);
      if (!cifra || cifra < 8) return; /* con cifras cortas no hay cuento */
      n.dataset.vivoCifra = cifra;
      n.dataset.vivoTexto = texto;
      io.observe(n);
    });

    function contar(n) {
      var fin = parseInt(n.dataset.vivoCifra, 10);
      var DURACION = 1400;
      var arranque = null;

      function paso(t) {
        if (arranque === null) arranque = t;
        var avance = Math.min((t - arranque) / DURACION, 1);
        /* La curva también aquí: arranca ligera y frena al llegar. */
        var suave = 1 - Math.pow(1 - avance, 3);
        n.textContent = Math.round(fin * suave);
        if (avance < 1) {
          requestAnimationFrame(paso);
        } else {
          n.textContent = n.dataset.vivoTexto; /* el formato original, con puntos */
        }
      }
      requestAnimationFrame(paso);
    }
  }

  /* ---------- Arranque ---------- */

  function iniciar() {
    arrancarMedidor();

    if (!anima) return;

    document.documentElement.classList.add('cs-vivo-anima');
    if (forzado) document.documentElement.classList.add('cs-vivo-forzado');

    coreografiarHero();
    coreografiarMosaico();

    /* Las entradas y los contadores miden DÓNDE está cada pieza, y en
       DOMContentLoaded las imágenes aún no han dado su altura: la página
       está comprimida y todo parece "en pantalla", así que la coreografía
       se dispararía entera de golpe. Se espera a `load` (geometría real) —
       con un tope por si algún recurso se eterniza. */
    var coreografiado = false;
    var coreografiar = function () {
      if (coreografiado) return;
      coreografiado = true;
      coreografiarEntradas();
      coreografiarContadores();
    };

    if (document.readyState === 'complete') {
      coreografiar();
    } else {
      window.addEventListener('load', coreografiar, { once: true });
      setTimeout(coreografiar, 2500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
